import { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import FooterNav from '../../components/dashboard/FooterNav';
import Navbar from '../../components/dashboard/Navbar';
import Slider from '../../components/Slider';
import Main from '../../components/dashboard/Main';
import PoComponent from '../../components/dashboard/PreOrder';
import PoDetailComponent from '../../components/dashboard/PoDetail';

import axios from  'axios';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate, useParams } from "react-router-dom";

const verifyToken = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }
    const decoded = jwtDecode(serviceToken);
    /**
     * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
     */
    return decoded.exp > Date.now() / 1000;
};

const PoDetail = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [token, setToken] = useState(
        JSON.parse(localStorage.getItem('token')) !== null ? 
            JSON.parse(localStorage.getItem('token')).token :
            null
    );
    const [data, setData] = useState([]);
    const [poForm, setPoForm] = useState([]);
    const [poSubdb, setPosubdb] = useState([]);
    const [stokInfo, setStokInfo] = useState([]);
    const [withStok, setWithStok] = useState(false);
    const [openPo, setOpenPo] = useState([]);

    const [cartState, setCartState] = useState([]);

    const [page, setPage] = useState({ value: 1 });
    const [pageInfo, setPageInfo] = useState(null);
    const [pageSize, setPageSize] = useState({ value: 24 });
    
    useEffect(() => {
        const refreshToken = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/token`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                console.log(response.data.token);
                if (response.data.token) {
                    setToken(response.data.token);
                    localStorage.setItem('token', JSON.stringify(response.data));
                }
                
            } catch (error) {
                console.log(token);
                // if (error.response) {
                // navigate('/');
                // }
            }
        };

        const getPoDetail = async () => {
            try {
                const po = await axios.get(
                  `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/detail/${params.idproduk}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                  });
                await setData(po.data.result);
                await getFormPo(po.data.result.idpoproduk, po.data.result.invoice);

            } catch (err) {
                console.log(err);
            }
        }

        const getOpenPo = async () => {
            try {
                const po = await axios.get(
                  `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/opened/${params.idproduk}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                  });
                await setOpenPo(po.data.result);

            } catch (err) {
                console.log(err);
            }
        }

        const getPoSubdb = async () => {
            try {
                const po = await axios.get(
                  `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/subdb`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    },
                    params: {
                        idpoproduk: params.idproduk,
                        page: 1,
                        perPage: pageSize.value
                    }
                });

                setPosubdb(po.data.result.data);
                const pageInfoRes = Object.keys(products.data.result)
                    .filter((key) => {
                        if (key !== 'data') return true;
                        return false;
                    })
                    .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
                setPageInfo(pageInfoRes);

            } catch (err) {
                console.log(err);
            }
        }

        const getFormPo = async (idpoproduk, invoice) => {
            try {
                const poform = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/update/${idpoproduk}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    },
                    params: {
                        idpoproduk,
                        invoice
                    }
                });

                let arrStok = [];
  
                if (poform.data.result.jenis_po === "PO dengan Stok") {
                    setWithStok(true);
                    const mappedStok = poform.data.result.form.map((e) => {
                        return { idpo: e.idpo, namakategori: e.namakategori, stok: e.stok }
                    })
                    arrStok = mappedStok.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.idpo === value.idpo
                        ))
                    );
                }

                await setPoForm(poform.data.result);
                await setStokInfo(arrStok);
  
            } catch (err) {
                console.log(err);
            }
        };
        const getCart = async () => {
            try {
              const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
              });
              setCartState(cartData.data.result);
            } catch (err) {
              console.log(err);
            }
        };

        if(!verifyToken(token)){
            localStorage.removeItem('token');
            navigate('/');
        }

        getPoDetail();
        getPoSubdb();
        getCart();
        getOpenPo();
        // refreshToken();

    }, []);

    return (
        <div>
            <Navbar cartState={cartState} UpdatedCartState={setCartState} />
            <PoDetailComponent
                poData={data}
                poForm={poForm}
                withStok={withStok}
                updatedWithStok={setWithStok}
                updatedStokInfo={setStokInfo}
                updatedPoForm={setPoForm}
                page={page}
                pageInfo={pageInfo}
                pageSize={pageSize}
                stokInfo={stokInfo}
                poSubdb={poSubdb}
                updatedPoSubdb={setPosubdb}
                updatedPage={setPage}
                updatedPageInfo={setPageInfo}
                updatedPageSize={setPageSize}
                openPo={openPo}
            />
            <FooterNav />
        </div>
    )
};

export default PoDetail;

